import type { ReactNode } from 'react';
import type { IconType } from 'react-icons';
import './EmptyState.css';

interface EmptyStateProps {
  /** Decorative icon — always `aria-hidden` (§1.3 color/icon-independence); the title/hint text
   * carries the actual message. See docs/design/14-tables-forms-restyle-spec.md §4.1's icon map. */
  icon: IconType;
  title: string;
  hint: string;
  action?: ReactNode;
}

/**
 * Restyled empty-state — 14-tables-forms-restyle-spec.md §4.1. Structure only (icon circle / title
 * / hint / optional CTA) — each list page still owns *when* to show the "filtered, no matches"
 * variant vs. the "no records yet" variant and which CTA (if any) to render.
 */
export function EmptyState({ icon: Icon, title, hint, action }: EmptyStateProps) {
  return (
    <div className="fa-empty-state">
      <span className="fa-empty-state__icon" aria-hidden="true">
        <Icon />
      </span>
      <p className="fa-empty-state__title">{title}</p>
      <p className="fa-empty-state__hint">{hint}</p>
      {action && <div className="fa-empty-state__action">{action}</div>}
    </div>
  );
}
